<template>
  <v-dialog v-model="model" max-width="400">
    <template #activator="{ on }">
      <slot name="activator" :on="on" />
    </template>
    <v-card>
      <v-card-title class="error--text"> Delete </v-card-title>
      <v-card-text class="title"> Confirm to delete {{ address.name }}? </v-card-text>
      <v-card-actions>
        <v-btn color="error" :loading="loading" class="ml-auto" text @click="onSubmit">
          Delete
          <v-icon right> mdi-delete </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { deleteCloudAddress } from "@/api/api";
import { rules } from "../../mixins/rulesMixin";

export default {
  props: {
    address: { type: Object, required: true },
    value: Boolean,
  },
  data() {
    return {
      crud: {
        name: this.address.name,
      },
      loading: false,
      rules,
      model: this.value,
    };
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      try {
        await deleteCloudAddress(this.address, this.crud.name);
        this.$emit("delete-address", this.address.uuid);
        this.model = false;
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    value(val) {
      this.model = val;
    },
    model(val) {
      this.$emit("input", val);
    },
  },
};
</script>
